export default function PlaceholderCard() {
    return (
        <li className="h-[200px] min-w-[250px] w-full max-w-[300px] animate-pulse bg-xv-placeholder-bg motion-reduce:animate-none"></li>
    );
}
